<template>
    <div class="p-t-xs-20 p-b-xs-20">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="m-b-xs-20">
                        <ak-button
                            size="small"
                            @click="backToGrid"
                        >
                            <i class="ak-icon ak-button__icon">arrow_left</i>
                            {{ $t('Ga terug') }}
                        </ak-button>
                    </div>
                </div>
            </div>
            <div v-if="doubles" class="col-lg-12">
                <div v-for="(level, index) in doubles" :key="index" class="ak-panel ak-panel--no-padding m-b-xs-20">
                    <div :class="`ak-panel__header ak-panel__header--small ak-panel__header--${getLevelAlert(index)}`">
                        <div class="ak-panel__title" v-html="getLevelTitle(index)">
                        </div>
                    </div>
                    <div class="ak-panel__body ak-panel__body--small reading">
                        <table class="ak-table ak-panel__table">
                            <thead>
                                <tr class="ak-table-row">
                                    <th class="ak-table-head">
                                        {{ $t('E-mailadres') }}
                                    </th>
                                    <th class="ak-table-head">
                                        {{ $t('Achternaam') }}
                                    </th>
                                    <th class="ak-table-head">
                                        {{ $t('Voornaam') }}
                                    </th>
                                    <th class="ak-table-head">
                                        {{ $t('Geboortedatum') }}
                                    </th>
                                    <th class="ak-table-head">
                                        {{ $t('Adres') }}
                                    </th>
                                    <th class="ak-table-head">
                                        {{ $t('Organisatie') }}
                                    </th>
                                    <th class="ak-table-head">
                                        {{ $t('Laatste bezoek') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="ak-table-body">
                                <template v-for="(entry, index2) in level">
                                    <template v-for="(double, index3) in entry">
                                        <tr class="ak-table-row">
                                            <td class="ak-table-column" v-bind:style="index3 === 1 ? 'border-bottom:2px solid #aaa;' : ''">
                                                <a href="#" @click.prevent="openUserForm(double.hashId)">
                                                    {{ double.email }}
                                                </a>
                                            </td>
                                            <td class="ak-table-column" v-bind:style="index3 === 1 ? 'border-bottom:2px solid #aaa;' : ''">
                                                {{ double.surname }}
                                            </td>
                                            <td class="ak-table-column" v-bind:style="index3 === 1 ? 'border-bottom:2px solid #aaa;' : ''">
                                                {{ double.firstName }}
                                            </td>
                                            <td class="ak-table-column" v-bind:style="index3 === 1 ? 'border-bottom:2px solid #aaa;' : ''">
                                                {{ double.birthDateForDisplay }}
                                            </td>
                                            <td class="ak-table-column" v-bind:style="index3 === 1 ? 'border-bottom:2px solid #aaa;' : ''">
                                                {{ double.fullAddress }}
                                            </td>
                                            <td class="ak-table-column" v-bind:style="index3 === 1 ? 'border-bottom:2px solid #aaa;' : ''">
                                                {{ double.organisationTitle }}
                                            </td>
                                            <td class="ak-table-column" v-bind:style="index3 === 1 ? 'border-bottom:2px solid #aaa;' : ''">
                                                {{ double.dateLastVisitForDisplay }}
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <router-view
            name="childview"
        />
        <ak-loader size="large" :loading="loading" />
    </div>
</template>

<script>
export default {
    name: 'UserDetectDoubles',
    data() {
        return {
            doubles: null,
            loading: false,
        }
    },
    methods: {
        async initialize() {
            this.loading = true;
            const result = await this.$get('/user-detect-doubles/');
            if (result.success) {
                this.doubles = result.data.doubles;
            }

            this.loading = false;
        },
        backToGrid() {
            this.$router.push({name: 'grid', params:{bundle: 'user', gridDefinition: 'grid'}});
        },
        openUserForm(hashId) {
            this.$router.push({name: 'user-detect-doubles-form', params:{bundle: 'user', definition: 'form', objectId: hashId}});
        },
        getLevelTitle (level) {
            switch (level) {
                case '1':
                    return '<b>Hoog</b> - Controle op naam, geboortedatum en postcode';
                case '2':
                    return '<b>Gemiddeld</b> - Controle op naam en geboortedatum';
                case '3':
                    return '<b>Laag</b> - Enkel controle op naam';
            }
        },
        getLevelAlert (level) {
            switch (level) {
                case '1':
                    return 'danger';
                case '2':
                    return 'warning';
                case '3':
                    return 'info';
            }
        }
    },
    created() {
        this.initialize();
    }
}
</script>
